import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Alert, Media, UpdateAlert, UpdateState } from '@classes/alert/alert';
import { Camera, latlngConvert } from '@classes/camera/camera';
import { Logs } from '@classes/logs/logs';
import { CameraWaste } from '@classes/waste-camera/waste-camera';
import { environment } from '@environments/environment';
import { faCircle, faLink, faMapMarkedAlt, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { alertService } from '@services/alert/alert.service';
import { CamerasService } from '@services/cameras/cameras.service';
import { mediaService } from '@services/media/media.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { ThumbnailComponent } from '../thumbnail/thumbnail.component';
import { VideoWasteComponent } from '../video-waste/video-waste.component';

const reader = new FileReader();

interface Etat {
  value: string;
  viewValue: string;
}
interface Niveaux {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-historique',
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.scss']
})
export class HistoriqueComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() alert: Alert[];
  lat = 50.597551;
  lng = 3.403683;
  zoom = 7.8;
  id: any;
  logs: Logs[];
  dateDiff: number;
  camera: Camera[];
  faCircle = faCircle;
  timeCircle = faTimes;
  falink = faLink;
  faSearch = faSearch;
  faMarker = faMapMarkedAlt;
  smartWaste: Logs[];
  choiceDateForm: UntypedFormGroup;
  today = new Date();
  // priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
  choiceViewBox = ['Tous', 'Caméras', 'Alertes'];
  selectViewChoice = 'Tous';
  screenOptions = {
    position: 2
  };

  displayedColumns: string[] = ['date', 'camera', 'status', 'etat', 'localisation', 'source', 'aperçu'];
  dataSource: MatTableDataSource<Alert>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];

  etats: Etat[] = [
    { value: 'UnTreated', viewValue: 'Non traitée' },
    { value: 'InProgress', viewValue: 'En cours' },
    { value: 'Treated', viewValue: 'Traitée' },

  ];

  niveaux: Niveaux[] = [
    { value: 'Low', viewValue: 'Faible' },
    { value: 'Medium', viewValue: 'Moyen' },
    { value: 'High', viewValue: 'Urgent' },

  ];

  cameras: CameraWaste[];
  alerts: Alert[];

  constructor(
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private alertService: alertService,
    private mediaService: mediaService,
    private sanitizer: DomSanitizer,
    private cameraService: CamerasService,
  ) {
    super();
  }
  ngOnInit(): void {
    // this.getLogs();
    this.initForm();
    this.getAlerts();
    this.getCameras();

  }
  onSubmit(changeCamera: boolean): void {
    const startDate = new Date(this.f.from.value);
    const endDate = new Date(this.f.to.value);
    const niveauAlerte = this.f.niveau.value ?? null;

    const cameraAlerte = this.f.camera.value ?? null;

    const etatAlerte = this.f.etat.value ?? null;

    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);

    this.getAlerts(this.choiceDateForm.value)
    // const alerts = this.alerts.filter(a => { new Date(a.date).getTime() >= startDate.getTime() && new Date(a.date).getTime() <= endDate.getTime() && a.state === etatAlerte && a.camera === cameraAlerte && a.status === niveauAlerte })

    // this.dataSource = new MatTableDataSource<Alert>(alerts)

  }

  changeValueInputFrom(): void {
    const dateFrom = new Date(this.choiceDateForm.get('from').value).getTime();
    const dateTo = new Date(this.choiceDateForm.get('to').value).getTime();
    const niveauAlerte = this.f.niveau.value ?? null;
    const cameraAlerte = this.f.camera.value ?? null;
    const etatAlerte = this.f.etat.value ?? null;

    const date = new Date(this.choiceDateForm.get('to').value);
    date.setDate(date.getDate() - 7);

    if (dateTo <= dateFrom) {
      this.choiceDateForm.get('from').setValue(date);

    }
    else {


    }

    const test = this.alerts.filter(a => { new Date(a.date).getTime() >= dateFrom && new Date(a.date).getTime() <= dateTo && a.state === etatAlerte && a.camera === cameraAlerte && a.status === niveauAlerte })

  }

  getEtatRoute(state: any): string {
    let etat: string = '';
    switch (state) {
      case 'UnTreated':
        etat = 'components.smartwaste.history.UnTreated.label'
        break;
      case 'InProgress':
        etat = 'components.smartwaste.history.inProgress.label'
        break;
      case 'Treated':
        etat = 'components.smartwaste.history.treated.label'
        break;

      default:
        break;
    }

    return etat
  }

  getStatusRoute(status: any): string {
    let Statut: string = '';
    switch (status) {
      case 'Low':
        Statut = 'components.smartwaste.history.Low.label'
        break;
      case 'Medium':
        Statut = 'components.smartwaste.history.Medium.label'
        break;
      case 'High':
        Statut = 'components.smartwaste.history.High.label'
        break;

      default:
        break;
    }

    return Statut
  }

  openDialogInfoCamera(alert: Alert, index: number): void {

    const dialogRef = this.dialog.open(VideoWasteComponent, {
      data: { alert, index, length: this.dataSource.filteredData.length }
    });

  }

  openDialogThumbnail(alert: Alert, index: number): void {

    const dialogRef = this.dialog.open(ThumbnailComponent, {
      data: { alert, index, length: this.dataSource.filteredData.length }
    });

  }


  hasThumbnail(medias: Media[]): boolean {

    const check = medias.find(m => m.type === 'Thumbnail')
    // return JSON.stringify(medias)?.includes('Thumbnail');
    return check ? true : false
  }

  updateMarker(el): void {

    this.lat = el.location.lat;
    this.lng = el.location.lng;
    this.zoom = 15
  }


  selectView(event) {
    this.selectViewChoice = event.value;
    // this.getLogs();
  }
  hasVideo(medias: Media[]): boolean {


    const check = medias.find(m => m?.uploadSession?.completedOn != null)
    // return false
    return check ? true : false
  }
  haveThumbnail(medias: Media[]): Media {
    return medias.find(m => m.type === 'Thumbnail');
  }


  get f() {
    return this.choiceDateForm.controls;
  }


  putEtat(id: string, event): void {

    const state = new UpdateState(event.value)
    this.alertService.putEtat(id, state).subscribe(() => { });

  }

  putAlertLevel(id: string, event): void {


    const status = new UpdateAlert(event.value)
    this.alertService.putAlert(id, status).subscribe(() => { });

  }

  private getCameras(): void {
    this.cameraService.getCameras().subscribe(res => {
      this.camera = res;
      this.choiceDateForm.get('cameraId').setValue(this.camera[0].name);

    });
  }

  private initForm(): void {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    this.choiceDateForm = this.formBuilder.group({

      from: [date, Validators.required],
      to: [this.today, Validators.required],
      etat: [''],
      niveau: [''],
      camera: ['']
    });


  }




  getAlerts(formValue?): void {
    let filters = null;
    if (formValue) {
      filters = formValue;
    }


    this.alertService.getAlert(filters).subscribe(res => {

      res.forEach(el => {
        const latLngSplit = (el.location as string).split(',')
        el.location = new latlngConvert(+latLngSplit[0], +latLngSplit[1])

      });

      this.alerts = res;


      this.length = res.length;
      this.dataSource = new MatTableDataSource<Alert>(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

    });
  }
}
